import { render, staticRenderFns } from "./TeamChallengeResults.vue?vue&type=template&id=336a2eca&scoped=true&"
import script from "./TeamChallengeResults.vue?vue&type=script&lang=js&"
export * from "./TeamChallengeResults.vue?vue&type=script&lang=js&"
import style0 from "./TeamChallengeResults.vue?vue&type=style&index=0&id=336a2eca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336a2eca",
  null
  
)

export default component.exports